import { useContext, useState } from "react";
import { MasterConfigContext } from "@/context/MasterConfigContext";
// import sendGAEvent from "@/utils/gaEvent";
import dayjs from "dayjs";
import defaultAuthor from "@/constants/defaultAuthor";


const CommonFooter = ({
  content = null,
  categoryNewsList = null,
  faqData = null,
  isMobileDevice = false,
  showAds = false,
  scrolled = false,
  showContent = false,
}) => {
  const masterConfig = useContext(MasterConfigContext);
  //   const iplKeys = masterConfig["ipl_2025"];
  const [readMore, setReadMore] = useState(true);

  return (
    <div className="mx-0 md:mx-4">
      <div className="flex flex-col justify-between  items-center md:items-start text-center md:text-left">
        <div className="space-y-4 mx-0 md:mx-4">
          {categoryNewsList?.map((content) => (
            <a
              key={content.id}
              href={content?.canonical_url ?? ""}
              target={content?.publishtime ? "_blank" : "_self"}
              className="border border-white-400 shadow-sm p-3 rounded-lg   flex flex-col md:flex-row md:min-w-[100%]  gap-4 hover:text-[#CF4C9B]"
            >
              {/* Image on Top (mobile) / Left (desktop) */}
              <img
                src={content.image_small}
                alt="story"
                className="w-full md:w-[180px] h-48 md:h-24 object-cover rounded-md flex-shrink-0"
              />

              {/* Text Content */}
              <div className="flex flex-col  justify-between  items-start md:items-start text-left md:text-left ">
                <h3 className="font-semibold text-sm leading-tight text-black hover:text-[#CF4C9B]">
                  {content.title_short}
                </h3>
                <p className="text-gray-600 text-sm mt-1 line-clamp-2">
                  {content.description_short}
                </p>

                <div className="flex items-center justify-center md:justify-start text-xs text-gray-500 mt-2 gap-2">
                  <img
                    className="h-[16px] w-[16px] inline-block"
                    alt="read video icon"
                    loading="lazy"
                    height={16}
                    width={16}
                    src={
                      content?.content_type === "video"
                        ? "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/watchType.svg"
                        : "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/readType.svg"
                    }
                  />
                  <time dateTime={content?.datetime_published}>
                    {dayjs(content?.datetime_published).format("MMM DD YYYY")}
                  </time>
                  · <span className="ml-0">By </span>
                  <a
                    href={
                      content?.author?.[0]?.canonical_url ??
                      defaultAuthor.canonical_url
                    }
                  >
                    <span className="text-[#CF4C9B]  underline">
                      {content?.author?.[0]?.title
                        .split(" ")
                        .slice(0, 2)
                        .join(" ") ?? defaultAuthor.title}
                    </span>
                  </a>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>

      {/* description  */}
      {content && (
        <div className="mx-4">
          <h2 className="flex mt-12 mb-2 gap-2 items-start">
            <span className="bg-[#CF4C9B] w-2 h-4"></span>
            <span className="text-lg font-semibold -mt-1">
              Bihar Tak Baithak
            </span>
          </h2>
          <p className={`text-[#323232] text-sm text-left relative inline`}>
            <span className={`${readMore ? "line-clamp-2" : ""}`}>
              {content}
            </span>
            <span
              onClick={() => {
                setReadMore((prev) => !prev);
              }}
              className="cursor-pointer inline ml-[5px]  text-[#CF4C9B] text-sm"
            >
              {readMore ? "और देखें >" : "< कम देखें"}
            </span>
          </p>
        </div>
      )}
    </div>
  );
};

export default CommonFooter;
